import React, { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';

/**
 * Halaman share task — redirect ke task detail.
 * URL: /share/task/:taskId
 * Crawler (WhatsApp, Telegram) akan dapat OG tags dari backend via nginx.
 * User biasa akan redirect ke /tasks?task=<id> yang auto-open TaskDetailFullModal.
 */
export default function ShareTaskPage() {
    const { taskId } = useParams();
    const navigate = useNavigate();

    useEffect(() => {
        const token = localStorage.getItem('token');
        if (token) {
            // TasksPage sudah punya deep-link support: ?task=<id> auto-open modal
            navigate(`/tasks?task=${taskId}`, { replace: true });
        } else {
            // Belum login -> simpan redirect URL ke localStorage (consisten dengan LoginPage)
            // lalu redirect ke login. Setelah login sukses, LoginPage akan baca ini.
            const redirectUrl = `/share/task/${taskId}`;
            localStorage.setItem('post_login_redirect', redirectUrl);
            navigate('/login', { replace: true });
        }
    }, [taskId, navigate]);

    return (
        <div className="flex items-center justify-center min-h-screen">
            <p className="text-gray-500">Loading task...</p>
        </div>
    );
}